import MaterialIcon from '@components/common/MaterialIcon';
import type { Sentiment } from '@conversed/shared/src/central/constants/sentiment';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { getSentimentLevel, SENTIMENT_DISPLAY } from '../sentimentDisplay';

type SentimentChipSize = 'default' | 'sm' | 'xs';

const SIZE_CLASSES: Record<SentimentChipSize, { chip: string; icon: string }> =
  {
    default: {
      chip: 'px-1.5 py-1 text-tiny leading-[normal]',
      icon: 'text-xs',
    },
    sm: {
      chip: 'px-1.5 py-1 text-pico leading-[normal]',
      icon: 'text-tiny',
    },
    xs: {
      chip: 'px-1 py-0.5 text-timestamp leading-[normal]',
      icon: 'text-pico',
    },
  };

type SentimentChipProps = {
  score?: number | null;
  sentiment?: Sentiment | null;
  size?: SentimentChipSize;
};

export const SentimentChip: React.FC<SentimentChipProps> = ({
  score,
  sentiment,
  size = 'default',
}) => {
  const { t } = useTranslation();

  const resolved: Sentiment | null =
    sentiment ?? (score != null ? getSentimentLevel(score) : null);

  if (resolved === null) {
    return null;
  }

  const display = SENTIMENT_DISPLAY[resolved];
  const sizeClass = SIZE_CLASSES[size];

  return (
    <span
      className={`intelligence__sentiment-chip ${display.chipClass} ${sizeClass.chip}`}>
      <MaterialIcon
        icon={display.icon}
        type='outlined'
        classes={[sizeClass.icon, '!leading-none']}
      />
      {t(display.labelKey)}
    </span>
  );
};
